import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps secondary buybox OTP link variant-aware when the main picker changes.
 */
class BuyOnceLinkSync {
  constructor() {
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
  }

  init() {
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  /**
   * @param {CustomEvent} event
   */
  onVariantUpdate(event) {
    const html = event.detail?.data?.html;
    const productId = event.detail?.data?.productId;
    if (!html || !productId) return;

    const nextLink = html.querySelector(
      `.quick-view-one-time-variant--link[data-product-id="${productId}"]`
    );
    const currentLink = document.querySelector(
      `.quick-view-one-time-variant--link[data-product-id="${productId}"]`
    );

    if (!nextLink || !currentLink) return;

    morph(currentLink, nextLink);
  }
}

const buyOnceLinkSync = new BuyOnceLinkSync();
buyOnceLinkSync.init();
